import { Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { useContext } from 'react';
import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const Preferences = () => {
  const { filters, setFilters, dispatchSuppliers } = useContext(
    DoctorsSuppliersContext
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const sortStyle: SxProps = {
    p: '6px 0 6px 16px',

    ':hover': {
      cursor: 'pointer',
      bgcolor: 'primary.shade_50_2',
    },
  };

  const preferencesHandler = (isHomeVisit: boolean) => {
    const updatedFilters = isHomeVisit
      ? {
          ...filters,
          accessible: null,
          homeVisit: true,
        }
      : {
          ...filters,
          homeVisit: null,
          accessible: true,
        };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.doctors,
      payload: { value: updatedFilters },
    });
  };

  const resetHandler = () => {
    const updatedFilters = {
      ...filters,
      accessible: null,
      homeVisit: null,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.doctors,
      payload: { value: updatedFilters },
    });
  };

  return (
    <Stack
      sx={{
        pb: '60px',
      }}
    >
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.accessible ? 'primary.shade_100' : undefined,
          fontWeight: filters.accessible ? '600 !important' : undefined,
        }}
        onClick={() => preferencesHandler(false)}
      >
        {dictionary.therapy.accessible}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.homeVisit ? 'primary.shade_100' : undefined,
          fontWeight: filters.homeVisit ? '600 !important' : undefined,
        }}
        onClick={() => preferencesHandler(true)}
      >
        {dictionary.therapy.homeTherapy}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor:
            !filters.accessible && !filters.homeVisit
              ? 'primary.shade_100'
              : undefined,
          fontWeight:
            !filters.accessible && !filters.homeVisit
              ? '600 !important'
              : undefined,
        }}
        onClick={() => resetHandler()}
      >
        {dictionary.noPreferences}
      </Typography>
      <ResetFilterButtons
        resetCallback={() => resetHandler()}
        sx={{
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
